import { SignInProvider } from '@context/SignIn';
import SignInView from './SignInView';

const SignIn = () => {
  return (
    <SignInProvider>
      <SignInView />
    </SignInProvider>
  );
};

export default SignIn;
